<template>
  <div class="v-input v-text-field theme--light">
    <div class="v-input__control">
      <div class="v-input__slot">
        <div class="v-text-field__slot">
          <label class="v-label theme--light minimizeLabel" aria-hidden="true">{{label}}</label>
          <input 
            ref="inputField"
            :aria-label="label"
            :autofocus="autofocus"
            :type="actualType"
            v-on:keyup.enter="submitFunction"
            v-bind:value="value"
            v-on:input="updateValue($event.target.value)"
            :autocomplete="autocomplete"
          />
          <div v-if="label==='Password'" class="input-group-append">
            <span class="input-group-text" @click="showPassword = !showPassword" style="cursor: pointer">
              <i class="fa" :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="true"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="v-text-field__details">
        <div class="v-messages theme--light">
          <div class="v-messages__wrapper">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isEmpty: true,
      isFocused: false,
      showPassword: false
    }
  },
  props: {
    value: String,
    label: String,
    submitFunction: Function,
    autofocus: Boolean,
    autocomplete: String,
    type: String
  },
  computed: {
    actualType() {
      if (this.label === 'Password') {
        return this.showPassword ? 'text' : 'password';
      }

      return this.type;
    }
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value);
    }
  },
  mounted () {
    const inputField = this.$refs.inputField;

    inputField.addEventListener('animationstart', () => {
        this.isEmpty = false;
    });

    inputField.addEventListener('focus', () => this.isFocused = true);

    inputField.addEventListener('blur', (event) => {
        this.isFocused = false;
        this.isEmpty = !Boolean(event.target.value.length);
    });

    inputField.addEventListener(('change'), (event) => {
      this.isEmpty = !Boolean(event.target.value.length);
    });
  }
}
</script>

<style>
@keyframes onAutoFillStart {  from {/**/}  to {/**/}}
input:-webkit-autofill {
    animation-name: onAutoFillStart;
    box-shadow: 0 0 0px 0px white inset;
    -webkit-box-shadow: 0 0 0px 0px white inset;
    transition: background-color 50000s ease-in-out 0s;
}

.Herdwatch .v-input .v-label {
  color: white !important;
}

.Herdwatch .v-input__slot {
  background-color: white !important;

}

label:not([for=fromDate]):not([for=toDate]) {
  left: 0px;
  right: auto;
  position: absolute;
  font-size: 16px;
  line-height: 1;
  min-height: 8px;
  transition: .3s cubic-bezier(.25,.8,.5,1);
}

.minimizeLabel {
  max-width: 133%;
  -webkit-transform: translateY(-18px) scale(.75);
  transform: translateY(-18px) scale(.75);
}
</style>



// WEBPACK FOOTER //
// src/components/InputAutofill.vue